module.exports = __webpack_public_path__ + "img/42.f060a5ed.png";